
import {
  defineComponent, ref, watch,
} from 'vue';
import {
  Table,
  ConfigProvider,
  Button,
  Popconfirm,
  message,
  Tabs,
} from 'ant-design-vue';
import { useRouter, } from 'vue-router';
import moment from 'moment';

import { getTraceHisList, deleteTraceInfo, } from '../traceabilityPageReq';

import zhCN from 'ant-design-vue/es/locale/zh_CN';
import store from '@/store';

const { TabPane, } = Tabs;

export default defineComponent({
  components: {
    Table,
    ConfigProvider,
    Button,
    Popconfirm,
    Tabs,
    TabPane,
  },
  props: {},
  setup () {
    // 列表行配置
    const columns = [
      {
        title: '序号',
        slots: { customRender: 'index', },
        rowKey: 'index',
        width: '8%',
      },
      {
        title: '操作时间',
        dataIndex: 'createTime',
        slots: { customRender: 'time', },
        rowKey: 'createTime',
        // sorter: true,
        ellipsis: true,
      },
      {
        title: '溯源时间',
        dataIndex: 'traceabilityTime',
        slots: { customRender: 'time', },
        rowKey: 'traceabilityTime',
        ellipsis: true,
      },
      {
        title: '溯源点',
        dataIndex: 'traceabilityPointName',
        rowKey: 'traceabilityPointName',
        ellipsis: true,
      },
      {
        title: '经纬度',
        dataIndex: 'lnglat',
        rowKey: 'lnglat',
        ellipsis: true,
      },

      /*
       * {
       *   title: '默认点',
       *   dataIndex: 'pointType',
       *   slots: { customRender: 'pointType', },
       *   rowKey: 'pointType',
       *   ellipsis: true,
       * },
       */
      {
        title: '状态',
        dataIndex: 'runStatus',
        slots: { customRender: 'runStatus', },
        rowKey: 'runStatus',
        ellipsis: true,
      },
      {
        title: '操作',
        slots: { customRender: 'op', },
        rowKey: 'op',
        // width: '12%',
      },
    ];

    const runStatus = [{ text: '失败', color: '#F77B59', },
      { text: '成功', color: '#46AC70', },
      { text: '运行中', color: '#277CF6', },
      { text: '未执行', color: '#999', },];

    const router = useRouter();

    // 表格数据
    const tableData = ref<any>([]);
    const oldPage = store.state.login.page;
    const oldTab = store.state.login.page;

    // 当前页面
    const current = ref<number>(1);
    // 数据总数
    const total = ref<number>(0);

    // 选中的tab
    const activeTab = ref<string>('1');

    /**
     * 加载表格数据
     * @param {number} pageNo 当前页码
     * @param {string} searchValue 查询字符
     * @param {string} pointType 查询字符
     * @return {void}
     */
    const loadTable = (pageNo = 1, searchValue = '',pointType:any): void => {
      const params = {
        pageNum: 0,
        pageSize: 0,
        pointType: Number(pointType),
      };

      getTraceHisList(params).then((res: any) => {
        // tableData.value = res;

        tableData.value = res.map((i: any) => ({
          createTime: i.createTime,
          id: i.id,
          pointType: Number(pointType),
          lnglat: `${i.lat.replace('.', '°')}'N,${i.lat.replace('.', '°')}'E`,
          runStatus: i.runStatus,
          traceabilityPointName: i.traceabilityPointName,
          traceabilityTime: i.traceabilityTime,
        }));
      });
      // store.dispatch('userCenter/getRoleList', params);
    };

    loadTable(1,'',1);

    /**
     * 页码切换
     * @method handleChange
     * @param {any[]} page 传入当前点击的页码
     * @param {any[]} pageSize 传入当前点击的页数
     * @return {void}
     */
    const handleChange = (page: any, pageSize: any) => {
      current.value = page;
      loadTable(page,'',Number(activeTab.value));
      store.commit('login/setActiveTab', page);
    };

    /**
     * @method showRole
     * @param {any} record 选择的溯源
     * @return {void} 轨迹
     */
    const showTrace = (record: any): void => {
      router.push(
        {
          path: '/logged/analysis/traceability',
          query: {
            id: record.id,
            name: record.traceabilityPointName,
            time: moment(record.traceabilityTime, 'YYYYMMDD HH:mm:ss').format('YYYYMMDDHH'),
          },
        }
      );

      /*
       * const params = {
       *   roleId: role.id,
       *   pageNo: 1,
       *   pageSize: 10,
       * };
       */

      /*
       * store.dispatch('userCenter/getSelectRoleInfo', params).then(() => {
       *   infoVisible.value = true;
       * }).catch((msg) => {
       *   message.warn(msg);
       * });
       */
    };

    /**
     * @method deleteConfirm
     * @param {any} record 删除的数据
     * @return {void} 单个删除
     */
    const deleteConfirm = (record: any): void => {
      const { id, } = record;

      deleteTraceInfo({ id, }).then(() => {
        message.success('删除成功');
        loadTable(1,'',Number(activeTab.value));
      });

      /*
       * 调取接口删除
       * store.dispatch('userCenter/deleteRoleAll', [id,]).then(() => {
       *   loadTable(current.value, searchValue.value);
       * }).catch((msg) => {
       *   message.error(msg);
       * });
       */
    };

    watch(activeTab, (val:any) => {
      if (val === '0') {
        loadTable(1,'',0);
      } else {
        loadTable(1,'',1);
      }
      store.commit('login/setActiveTab', val);
    });

    return {
      zhCN,
      columns,
      runStatus,
      tableData,
      current,
      total,
      moment,
      activeTab,
      handleChange,
      showTrace,
      deleteConfirm,
    };
  },
  // mounted () {},
});
